import type { Component, Entity2D } from '../../odie';

import { WormBlockProps } from '../defs/block';
import { WormBlockView } from '../views/blocks/WormBlockView';

// types
//-----------------------------------------------------------------------------
export type WormBlockComponentOptions = {
  props: WormBlockProps;
};

/*
    worm block component
*/
export class WormBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockWorm';

  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: WormBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: WormBlockComponentOptions): void {
    this.view = new WormBlockView({ ...options.props });
  }
}
